import React from "react";

const CloseLockIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.3125 6.5625V4.21875C10.3125 3.47283 10.0162 2.75746 9.48874 2.23001C8.96129 1.70257 8.24592 1.40625 7.5 1.40625C6.75408 1.40625 6.03871 1.70257 5.51126 2.23001C4.98382 2.75746 4.6875 3.47283 4.6875 4.21875V6.5625M4.21875 13.5938H10.7812C11.1542 13.5938 11.5119 13.4456 11.7756 13.1819C12.0393 12.9181 12.1875 12.5605 12.1875 12.1875V7.96875C12.1875 7.59579 12.0393 7.2381 11.7756 6.97438C11.5119 6.71066 11.1542 6.5625 10.7812 6.5625H4.21875C3.84579 6.5625 3.4881 6.71066 3.22438 6.97438C2.96066 7.2381 2.8125 7.59579 2.8125 7.96875V12.1875C2.8125 12.5605 2.96066 12.9181 3.22438 13.1819C3.4881 13.4456 3.84579 13.5938 4.21875 13.5938Z" stroke="#2158D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>  
  );
};

export default CloseLockIcon;
